import type { SVGProps } from "react";

export default function DoubleCheckIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.66504 10.75L6.28409 13.75L12.8317 6.25"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9995 6.30273L9.85643 13.8027L9.49951 13.334"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
